import { useLayoutEffect } from 'react';
export var MINDSET_HIDE_SIDEBAR_EVENT = 'mindset:hide-sidebar';
export var MINDSET_SHOW_SIDEBAR_EVENT = 'mindset:show-sidebar';
var hideRequestCount = 0;
export function isMindsetSidebarHidden() {
  return hideRequestCount > 0;
}

/**
 * Hides the persistent Mindset sidebar while the calling component is mounted —
 * for pages/components that embed their own Mindset agent instead (e.g. MindsetCard),
 * to avoid two simultaneous agent instances.
 */
export function useHideMindsetSidebar() {
  useLayoutEffect(function () {
    if (typeof window === 'undefined') return;
    hideRequestCount += 1;
    if (hideRequestCount === 1) {
      window.dispatchEvent(new CustomEvent(MINDSET_HIDE_SIDEBAR_EVENT));
    }
    return function () {
      hideRequestCount = Math.max(0, hideRequestCount - 1);
      if (hideRequestCount === 0) {
        window.dispatchEvent(new CustomEvent(MINDSET_SHOW_SIDEBAR_EVENT));
      }
    };
  }, []);
}